/**
 * These functions help with resizing the "External Content" Iframe of LernBar to
 * the actual content height displayed in the iframe.
 * 
 * Assumptions / Requirements:
 * 
 *   - content loaded in the iframe resides on the same domain as the learning unit (which is the case as of 2021-03-xx)
 *   
 *   - markup used in LernBar:
 *       div.widget-content
 *         div.embed-container
 *           iframe 
 * 
 * The .embed-container has a padding-bottom set to keep its aspect ratio constant.
 * This is neat for content like images and videos, but not so much for variable content
 * like text. 
 * The iframe's height will be set to the actual content height and padding-bottom
 * of .embed-container set to 0.
 */



// from https://stackoverflow.com/questions/3151665/how-to-get-parent-iframe-element-from-inner-page-without-knowing-id
//
// get the LernBar Iframe this app is loaded in
export function getParentFrame() {
  // var frame = parent.document.querySelector('iframe[src*=P42]')
  
  var allFrames = window.top.document.getElementsByTagName("iframe")
  var i = 0
  var l = allFrames.length
  var currentFrame
  var currentDoc

  // console.log( '📑📑📑 allFrames', allFrames);

  // loop through all iframes and compare app document with frame document
  for(i; i < l; i++)  {
    currentFrame = allFrames[i]
    try {
      currentDoc = currentFrame.contentDocument || currentFrame.contentWindow.document
    } catch (error) {
      // NOT using try/catch would result in CORS / DOMException error when trying to access/compare
      // any of those other LernBar iFrames:
      // https://nonproliferation-elearning.eu/matomo/index.php?module=CoreAdminHome...
      // https://start.video-stream-hosting.de/player_videojs.html?serverip=62.113.210.7...
      // https://www.blitzvideoserver.de/player_hsfk.html?serverip=62.113.210.7...
      // before reaching
      // pages/P42/resource\examples.html
      // console.warn( 'ERROR when trying to get parent frame \n\n', error, '\n\n', currentFrame.src, '\n\n', currentFrame.dataset.src )
    }
    if(currentDoc === document) {
      // console.log('✨ found parent frame', currentFrame)
      return currentFrame;
    }
  }
  // console.log('🧦😭 parent frame not found')
  return null;
}


export function setParentFrameHeight( frame, height ){
  if (!frame) return;
  if (!height) return;

  // set frame height to app height
  frame.style.height = height+'px'

  // remove position:absolute to prevent frame's parent .embed-container from collapsing
  frame.style.position = 'static'

  // remove parents padding-bottom which was used to lock width/height to specific ratio
  frame.parentNode.style.paddingBottom = '0'
}
